import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { getFormattedValue } from "../../../../utils/previewValueFormatterUtils";
import { PreviewCardLayout } from "./PreviewCardLayout";

interface SpaceGroupCardProps {
  params: Record<string, string>;
  url: string;
}

export const SpaceGroupCard = ({ params, url }: SpaceGroupCardProps) => {
  const PROFILE_FIELDS = {
    name: { label: t("space_groups.form.create.name"), type: "string" },
    slug: {
      label: t("space_groups.form.create.slug"),
      type: "string",
    },
    hide_members_count: {
      label: t("space_groups.form.create.hide_members_count"),
      type: "boolean",
    },
    hide_non_member_spaces_from_sidebar: {
      label: t("space_groups.form.hide_non_member_spaces_from_sidebar"),
      type: "boolean",
    },
    is_hidden_from_non_members: {
      label: t("space_groups.form.create.is_hidden_from_non_members"),
      type: "boolean",
    },
    allow_members_to_create_spaces: {
      label: t("space_groups.form.allow_members_to_create_spaces"),
      type: "boolean",
    },
  };

  return (
    <PreviewCardLayout
      title={t(
        "help_widget.copilot.preview_cards.create_space_group_card_title",
      )}
      url={url}
    >
      <ul className="flex flex-col leading-5">
        {Object.entries(PROFILE_FIELDS).map(
          ([key, keyProps]) =>
            key in params &&
            params[key] != null && (
              <li key={key} className="text-darkest !pb-0">
                <Typography.BodySm color="text-darkest">
                  <strong>{keyProps.label}:</strong>{" "}
                  {getFormattedValue(params[key], keyProps.type)}
                </Typography.BodySm>
              </li>
            ),
        )}
      </ul>
    </PreviewCardLayout>
  );
};
